import Vue from 'vue'
import Router from 'vue-router'
import { stringifyQuery, parseQuery } from "@/router/utils/query";
const Hender = () => import('@/components/pc/top/topTitle')

Vue.use(Router)


// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'hash',
    routes:[
        {
          path: '/',
          meta: {title: '我才是真正的首页',encryptParams: true},
          name: 'index',
          redirect: '/workbench',
          // component: () => import('@/views/index'),
        },
        {
          path: '/mobile',
          meta: {title: '我才是真正的首页',encryptParams: true},
          name: 'index',
          redirect: '/mobile/index',
          // component: () => import('@/views/index'),
        },
        //mobile模块 移动端
        {
          path: '/mobile',
          meta: {title: '手机主页',encryptParams: true},
          name: 'mobile',
          // redirect: '/workbench',
          component: () => import('@/views/mobile/index'),
          children:[
            //齐即美主页
            {                
              meta: {title: '齐即美主页 ',encryptParams: true},
              path: 'index',
              name: 'mobile/index',
              components:{
                // hender:Hender,
                default: () => import('@/views/mobile/index/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/workbench/index')
            },
            {
              path: 'ill',
              meta: {title: '病例',encryptParams: true},
              name: 'mobile/ill',
              // redirect: '/workbench',
              component: () => import('@/views/mobile/ill/index'),
              children:[
                {                
                  meta: {title: '患者详情 ',encryptParams: true},
                  path: 'patientdetails',
                  name: 'mobile/ill/patientdetails',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/patientdetails/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/pc/system/workbench/index')
                },
                {                
                  meta: {title: '加工后续 ',encryptParams: true},
                  path: 'machining',
                  name: 'mobile/ill/machining',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/machining/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/pc/system/workbench/index')
                },
                {                
                  meta: {title: '阶段调整 ',encryptParams: true},
                  path: 'stageadjustment',
                  name: 'mobile/ill/stageadjustment',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/stageadjustment/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/pc/system/workbench/index')
                },
                {                
                  meta: {title: '完成病例 ',encryptParams: true},
                  path: 'finishcase',
                  name: 'mobile/ill/finishcase',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/finishcase/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/pc/system/workbench/index')
                },
                {                
                  meta: {title: '方案影像资料 ',encryptParams: true},
                  path: 'imagingData',
                  name: 'mobile/ill/imagingData',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/imagingData/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/pc/system/workbench/index')
                },
                {                
                  meta: {title: '复诊影像资料 ',encryptParams: true},
                  path: 'imagingFollowData',
                  name: 'mobile/ill/imagingFollowData',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/imagingFollowData/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/pc/system/workbench/index')
                },
                {                
                  meta: {title: '委托加工单 ',encryptParams: true},
                  path: 'subcontractList',
                  name: 'mobile/ill/subcontractList',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/subcontractList/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/pc/system/workbench/index')
                },
                {
                  // 临床分析报告
                  path: 'analysisReport',
                  meta: {title: '临床分析报告',encryptParams: false},
                  name: 'mobile/ill/analysisReport',
                  components:{
                    // hender:Hender,
                    default: () => import('@/views/mobile/ill/analysisReport/index'),
                    // footer:Footer,
                  } ,
                  // component: () => import('@/views/mobile/ill/analysisReport/index'),
                  // children:[
                  //   {                
                  //     meta: {title: '临床分析报告 ',encryptParams: false},
                  //     path: 'index',
                  //     name: 'mobile/ill/analysisReport/index',
                  //     components:{
                  //       // hender:Hender,
                  //       default: () => import('@/views/pc/analysisReport/index'),
                  //       // footer:Footer,
                  //     } ,
                  //     // component: () => import('@/views/pc/system/workbench/index')
                  //   },
                  // ]
                },
              ]
            },
            {                
              meta: {title: '个人信息 ',encryptParams: true},
              path: 'userInfo',
              name: 'mobile/userInfo',
              components:{
                // hender:Hender,
                default: () => import('@/views/mobile/other/userInfo/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/workbench/index')
            },
            {                
              meta: {title: '修改密码 ',encryptParams: true},
              path: 'modifyPassword',
              name: 'mobile/modifyPassword',
              components:{
                // hender:Hender,
                default: () => import('@/views/mobile/other/modifyPassword/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/workbench/index')
            },
          ]
        }, 
        //public模块 公共模块
        {
          path: 'public',
          meta: {title: '齐即美管理系统',encryptParams: true},
          name: 'public',
          // redirect: '/workbench',
          component: () => import('@/views/public//index'),
          children:[
            {
              // 登录
              path: '/login',
              meta: {title: '医生登录',encryptParams: true},
              name: 'login',
              component: () => import('@/views/public/login/index'),
            },
            {
              // 注册
              path: '/register',
              meta: {title: '医生注册',encryptParams: true},
              name: 'register',
              component: () => import('@/views/public/register/index'),
            },
            {
              // 忘记密码
              path: '/forgetPassword',
              meta: {title: '忘记密码',encryptParams: true},
              name: 'forgetPassword',
              component: () => import('@/views/public/forgetPassword/index'),
            },
            {
              //用户条例
              path: '/useRegulations',
              meta: {title: '用户条例',encryptParams: true},
              name: 'useRegulations',
              component: () => import('@/views/public/useRegulations/index'),
              children:[
                {
                  meta: {title: '用户使用协议',encryptParams: true},
                  path: '/useRegulations/privacyClause',
                  component: () => import('@/views/public/useRegulations/privacyClause/index'),
                },
                {
                  meta: {title: '用户隐私条款',encryptParams: true},
                  path: '/useRegulations/useAgreement',
                  component: () => import('@/views/public/useRegulations/useAgreement/index'),
                },
              ]
            },
            {
              //测试页面
              path: '/test',
              meta: {title: '测试页面',encryptParams: true},
              name: 'test',
              redirect: '/workbench',
              component: () => import('@/views/public/test/bg'),
              children:[
                {
                  meta: {title: '测试页面1',encryptParams: true},
                  path: '/test/test12345',
                  component: () => import('@/views/public/test/index'),
                },
                {
                  meta: {title: '测试页面2',encryptParams: true},
                  path: '/test/test2',
                  component: () => import('@/views/public/test/test2'),
                },
            {
              meta: {title: '测试页面3',encryptParams: true},
              path: '/test/test3',
              component: () => import('@/views/public/test/test3'),
            },
              ]
            },
          ]
        },
         //pc模块
        {
          path: '',
          meta: {title: '齐即美管理系统',encryptParams: true},
          name: 'coushude',
          // redirect: '/workbench',
          component: () => import('@/views/pc/index'),
          children:[
            //工作台
            {                
              meta: {title: '工作台',encryptParams: true},
              path: 'workbench',
              name: 'system/workbench',
              components:{
                hender:Hender,
                default: () => import('@/views/pc/system/workbench/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/workbench/index')
            },
            //病例
            {                
              meta: {title: '病例',encryptParams: true},
              path: 'illcase',
              name: 'system/illcase',
              redirect: '/illcase/illcaselist',
              components:{
                hender:Hender,
                default: () => import('@/views/pc/system/illcase/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/system/illcase/index'),
              children:[
                {
                  meta: {title: '病例状态',encryptParams: true},
                  path: '/illcase/illcaselist',
                  name: 'system/illcase/illcaselist',
                  component: () => import('@/views/pc/system/illcase/illcaselist/index'),
                },
                {
                  meta: {title: '病例编辑',useRegulationsencryptParams: true},
                  path: '/illcase/adultEdit',
                  name: 'system/illcase/adultEdit',
                  component: () => import('@/views/pc/system/illcase/editCase/adultEdit/index'),
                },
                {
                  meta: {title: '病例编辑',encryptParams: true},
                  path: '/illcase/childEdit',
                  name: 'system/illcase/childEdit',
                  component: () => import('@/views/pc/system/illcase/editCase/childEdit/index'),
                },
    
                {
                  meta: {title: '患者详情',encryptParams: true},
                  path: '/illcase/patientdetails',
                  name: 'system/illcase/patientdetails',
                  component: () => import('@/views/pc/system/illcase/patientdetails/index'),
                },
                {
                  meta: {title: '加工后续',encryptParams: true},
                  path: '/illcase/machining',
                  name: 'system/illcase/machining',
                  component: () => import('@/views/pc/system/illcase/machining/index'),
                },
                {
                  meta: {title: '阶段调整',encryptParams: true},
                  path: '/illcase/stageadjustment',
                  name: 'system/illcase/stageadjustment',
                  component: () => import('@/views/pc/system/illcase/stageadjustment/index'),
                },
                {
                  meta: {title: '完成病例',encryptParams: true},
                  path: '/illcase/finishcase',
                  name: 'system/illcase/finishcase',
                  component: () => import('@/views/pc/system/illcase/finishcase/index'),
                },
                {
                  meta: {title: '委托加工单',encryptParams: true},
                  path: '/illcase/subcontractList',
                  name: 'system/illcase/subcontractList',
                  component: () => import('@/views/pc/system/illcase/subcontractList/index'),
                },
                {
                  meta: {title: '3D方案',encryptParams: true},
                  path: '/illcase/threeDimensionalsCheme',
                  name: 'system/illcase/threeDimensionalsCheme',
                  component: () => import('@/views/pc/system/illcase/threeDimensionalsCheme/index'),
                },
                {
                  meta: {title: '影像资料',encryptParams: true},
                  path: '/illcase/imagingData',
                  name: 'system/illcase/imagingData',
                  component: () => import('@/views/pc/system/illcase/imagingData/index'),
                },
                {
                  meta: {title: '上传复诊资料',encryptParams: true},
                  path: '/illcase/imagingDataAdd',
                  name: 'system/illcase/imagingDataAdd',
                  component: () => import('@/views/pc/system/illcase/imagingDataAdd/index'),
                },
              ]
            },
            //患者 病例列表
            {                
              meta: {title: '病例列表',encryptParams: true},
              path: 'patient',
              name: 'system/patient',
              components:{
                hender:Hender,
                default: () => import('@/views/pc/system/patient/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/patient/index'),
            },
            //统计病例
            {                
              meta: {title: '统计病例',encryptParams: true},
              path: 'statistics',
              name: 'system/statistics',
              components:{
                hender:Hender,
                default: () => import('@/views/pc/system/statistics/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/statistics/index'),
            },
            //专家库
            {                
              meta: {title: '专家库',encryptParams: true},
              path: 'expert',
              name: 'system/expert',
              components:{
                hender:Hender,
                default: () => import('@/views/pc/system/expert/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/expert/index'),
            },
            // 个人信息
            {                
              path: '/userInfo',
              meta: {title: '个人信息',encryptParams: true},
              name: 'userInfo',
              components:{
                hender:Hender,
                default: () => import('@/views/pc/userInfo/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/userInfo/index'),
            },
            // 密码修改
            {                
              path: '/modifyPassword',
              meta: {title: '密码修改',encryptParams: true},
              name: 'modifyPassword',
              components:{
                hender:Hender,
                default: () => import('@/views/pc/system/modifyPassword/index'),
                // footer:Footer,
              } ,
              // component: () => import('@/views/pc/system/modifyPassword/index'),
            },
            // 3D全屏出去
            {                
              path: '/3dCheme',
              meta: {title: '3D方案',encryptParams: true},
              name: 'threeDCheme',
              component: () => import('@/views/pc/3dCheme/index'),
            },
            // 临床分析报告
            {
              // 临床分析报告
              path: '/analysisReport',
              meta: {title: '临床分析报告',encryptParams: false},
              name: 'analysisReport',
              component: () => import('@/views/pc/analysisReport/index'),
            },
            // 查看第三方模型
            {
              // 查看第三方模型
              path: '/3dChemeNew',
              meta: {title: '3D方案',encryptParams: true},
              name: 'threeDChemeNew',
              component: () => import('@/views/pc/3dCheme/templatePage'),
              children:[
                {
                  // 正丽
                  path: 'li',
                  meta: {title: '3D方案',encryptParams: true},
                  name: 'zhengli',
                  component: () => import('@/views/pc/3dCheme/li/index'),
                }
              ]
            },
          ]
        },  
                 
        // 404页面
        {
          // 404页面
          path: '/404',
          meta: {title: '找不到页面啦',encryptParams: true},
          name: '404',
          component: () => import('@/views/public/404/index'),
        },
        {
          // 未定义页面跳转
          path: '*',
          redirect: '/404'
        },
    ],
    base: process.env.BASE_URL,
    stringifyQuery: (query)=>{
      return stringifyQuery(query)
    },
    parseQuery: (query)=>{
      return parseQuery(query)
    },
})
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   const encryptParams = to.meta.encryptParams;
//   // 在这里可以获取到 encryptParams 参数，并进行相应的处理
//   next();
// });

// let toURL = null
// router.beforeEach((to, from, next) => {
//   if (toURL === to.path) {
//     next()
//   }
//   alert(222)
//   if (to.path !== from.path) {
//     toURL = to.path
//     router.replace(to.path)
//     next()
//   }
// })
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js